<div
    class="account-settings-card"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <h4>
        Profile
    </h4>
    <p>
        Mettez à jour vos informations personnelles ici.
    </p>
    <div class="row">
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Username
                    </mat-label>
                    <input matInput value="{{user.username}}">
                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Nom
                    </mat-label>
                    <input matInput value="{{user.name}}">
                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        E-mail
                    </mat-label>
                    <input matInput value="{{user.email}}">
                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Numéro de téléphone
                    </mat-label>
                    <input matInput value="{{user.phone}}">
                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Adresse
                    </mat-label>
                    <input matInput value="{{user.address}}">
                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Date de naissance
                    </mat-label>
                    <input matInput value="">
                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-25">
                <mat-form-field>
                    <mat-label>
                        Sélectionner
                    </mat-label>
                    <mat-select [(value)]="genderSelected">
                        <mat-option value="option1">
                            Homme
                        </mat-option>
                        <mat-option value="option2">
                            Femme
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-12">
            <div class="mb-25">
                <label class="main-label d-block lh-1 text-black">
                    Ajoutez votre biographie
                </label>
                <mat-form-field class="textarea">
                    <mat-label>
                        Écrire ici....
                    </mat-label>
                    <textarea matInput placeholder=""></textarea>
                </mat-form-field>
            </div>
        </div>
    </div>
    <h4>
        Votre photo
    </h4>
    <p>
        Elle sera affiché sur votre profil.
    </p>
    <div class="mb-25">
        <file-upload class="file-uploader" [multiple]="multiple"></file-upload>
    </div>
    <h4>
        Informations de contact
    </h4>
    <p></p>
    <div class="row">
        <!--
        <div class="col-sm-6 col-lg-4">
            <div class="mb-25">
                <label class="main-label d-block lh-1 text-black">
                    Facebook
                </label>
                <mat-form-field>
                    <mat-label>
                        Facebook
                    </mat-label>
                    <input matInput value="https://www.facebook.com/">
                </mat-form-field>
            </div>
        </div>
        <div class="col-sm-6 col-lg-4">
            <div class="mb-25">
                <label class="main-label d-block lh-1 text-black">
                    Twitter
                </label>
                <mat-form-field>
                    <mat-label>
                        Twitter
                    </mat-label>
                    <input matInput value="https://twitter.com/">
                </mat-form-field>
            </div>
        </div>
        -->
        <div class="col-sm-6 col-lg-4">
            <div class="mb-25">
                <label class="main-label d-block lh-1 text-black">
                    Linkedin
                </label>
                <mat-form-field>
                    <mat-label>
                        Linkedin
                    </mat-label>
                    <input matInput value="https://www.linkedin.com/">
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="btn-box">
        <button mat-button>
            Mettre à jour le profil
        </button>
        <button mat-button>
            Annuler
        </button>
    </div>
</div>